export const fieldLabel = {
    bodyPractitionerType: 'Hvor er du blevet undersøgt for din skade på kroppen?',
    bodyPractitionerHospitalName: 'På hvilket hospital foregik undersøgelsen/behandling?',
    bodyPractitionerDate: 'Hvornår blev du undersøgt',
    bodyPractitionerName: 'Navn på behandler/behandlingssted',
    bodyPractitionerAddress: 'Adresse',
    specificInvestigatedPreviouslyWhere: 'På hvilket hospital foregik undersøgelsen/behandling?',
    specificInvestigatedPreviouslyTreatmentAddress: 'Adresse',
    specificInvestigatedPreviouslyTreatmentName: 'Navn på behandler/behandlingssted',
    specificInvestigatedPreviouslyTreatmentDate: 'Årstal for undersøgelse'
};
